// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mk-0";
export var assigneeDetails = "_mk-1";
export var assigneeInfo = "_mk-2";
export var dropdownContainer = "_mk-4";
export var dropdownImage = "_mk-5";
export var editAssigneeInfo = "_mk-3";
export var editAssigneeModalContainer = "_mk-6";
export var hidden = "_mk-8";
export var input = "_mk-7";